// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 02/10/2023

import { ChangeDetectorRef, Component, HostListener, Renderer2 } from '@angular/core'
import { BaseController } from './base.controller';
import { ADN_PLUS, Action, ApiResponseModel, CtRadioComponent, CtReceiptComponent, CtRowComponent, CtStepperComponent, CtStepperItemComponent, EntityField, HttpService, breakpoints } from 'components';
import { Observable, combineLatest } from 'rxjs';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { defaultIfEmpty, take } from 'rxjs/operators';

@Component({
	selector: 'pa-vi04',
	template: `<div [id]="getId()" #target><div>`,
	providers: [CurrencyPipe]
})

export class PaVi04 extends BaseController {


	//view elements
	private radioColumn: HTMLElement;
	private receiptColumn: HTMLElement;
	private ssvmnRow : HTMLElement;
	private num_planilla : number;
	private doc_id_patrono : string;
	private planillaData : ApiResponseModel;

	//util
	private isMedium: boolean;
	private isSmall: boolean;
	private isExtraSmall: boolean;

	constructor(private renderer : Renderer2,
		private currencyPipe : CurrencyPipe,
		private router : Router) {
		super();
		this.setViewCode('PA_VI04');
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.checkScreenSize();
		this.manageColumnsStyle();
	}

	private checkScreenSize() {
		const screenWidth = window.innerWidth;
		this.isMedium = screenWidth >= breakpoints.L;
		this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
		this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */

	/**
	 * This function is executed when the screen starts, all the stored service data is obtained from the PA_VI03 or PA_VI02 screen.
	 * @param action 
	 */
	public onInitManageContent(action : Action): void {
		this.setContextData(action);
		this.checkScreenSize();
		this.manageColumnsStyle(action);
		this.disableFirstStep(action);
		this.setDataToReceipt(action);
	}

	public setNextStepData(action : Action): void {
		const stepper : CtStepperComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const stepperItem : CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[1]);
		const stepperItemRow : CtRowComponent = this.utilService.getComponentRef(action.actionParams[2]);
		this.setLasStepStyles(stepperItem, stepperItemRow);
		stepper.changeStep(stepper.getCurrentIndex() + 1);
	}

	public goToHome(): void {
		this.router.navigate(['/home']);
	}

	private setLasStepStyles(stepperItem: CtStepperItemComponent, row : CtRowComponent) {
		stepperItem.backButtonComponent.setButtonColorManually('DefaultButtonContainer');
		stepperItem.backButtonComponent.setIcon('fa fa-download');
		const rowHostElement = document.getElementById(row.getId());
		if(this.isMedium && this.isSmall){
			this.renderer.setStyle(rowHostElement, 'width', '80%');
		} else {
			this.renderer.setStyle(rowHostElement, 'width', '95%');
		}
	}

	private disableFirstStep(action: Action) {
		const stepperItem : CtStepperItemComponent = this.utilService.getComponentRef(action.conditionParams[2]);
		stepperItem.nextButtonComponent.setDisabled(true);
	}

	private manageColumnsStyle(action: Action = null) {
		if(action && !this.radioColumn && !this.receiptColumn) {
			this.initializeColumnStyles(action);
		}
		this.setDefaultStyles();
		this.applyResponsiveStyles();
	}

	private initializeColumnStyles(action: Action) {
		this.radioColumn = document.getElementById(this.getViewCode()+'_'+action.conditionParams[0]);
		this.receiptColumn = document.getElementById(this.getViewCode()+'_'+action.conditionParams[1]);
		this.ssvmnRow = document.querySelector('.row-eq-height');
		this.renderer.setStyle(this.ssvmnRow, 'padding-bottom', '0px');
	}

	private setDefaultStyles(): void {
		this.renderer.setStyle(this.radioColumn, 'background-color', 'white');
	}

	private applyResponsiveStyles(): void {
		if (this.isMedium) {
			this.applyMediumStyles();
		} else if (this.isExtraSmall) {
			this.applyExtraSmallStyles();
		} else {
			this.applyDefaultResizableStyles();
		}
	}

	private applyDefaultResizableStyles() {
		this.renderer.removeStyle(this.radioColumn, 'height');
		this.renderer.removeStyle(this.receiptColumn, 'height');
		this.renderer.removeStyle(this.radioColumn, 'padding');
		this.renderer.removeStyle(this.receiptColumn, 'padding-top');
		this.renderer.setStyle(this.radioColumn, 'padding-bottom','45px');
		this.renderer.setStyle(this.radioColumn, 'margin-bottom', '45px');
	}

	private applyExtraSmallStyles() {
		this.renderer.removeStyle(this.radioColumn, 'height');
		this.renderer.removeStyle(this.receiptColumn, 'height');
		this.renderer.removeStyle(this.radioColumn, 'padding');
		this.renderer.removeStyle(this.receiptColumn, 'padding-top');
		this.renderer.setStyle(this.radioColumn, 'padding-top','45px');
		this.renderer.setStyle(this.radioColumn, 'padding-bottom','45px');
		this.renderer.setStyle(this.radioColumn, 'margin-bottom', '45px');
	}

	private applyMediumStyles(): void {
		this.renderer.setStyle(this.radioColumn, 'height', '100vh');
		this.renderer.setStyle(this.receiptColumn, 'height', '100vh');
		this.renderer.setStyle(this.radioColumn, 'padding','100px');
		this.renderer.setStyle(this.receiptColumn, 'padding-top','100px');
	}

	private setContextData(action : Action) {

		const docIdPatrono$ = this.storeService.getStateObservable('docIdPatrono').pipe(
			take(1),
			defaultIfEmpty('')
		);
	
		const numPlanilla$ = this.storeService.getStateObservable('numPlanilla').pipe(
			take(1),
			defaultIfEmpty('')
		);
	
		combineLatest([docIdPatrono$, numPlanilla$]).subscribe({
			next: ([docIdPatrono, numPlanilla]: any) => {
				if (docIdPatrono === '') {
					this.router.navigate(['/home/view/PA_VI01']);
				} else {
					this.doc_id_patrono = docIdPatrono;
					const docIdPatronoInput = this.utilService.getComponentRef(action.conditionParams[4]);
					docIdPatronoInput.setValue(this.doc_id_patrono);
				}
	
				if (numPlanilla === '') {
					this.router.navigate(['/home/view/PA_VI01']);
				} else {
					this.num_planilla = numPlanilla;
					const numPlanillaInput = this.utilService.getComponentRef(action.conditionParams[3]);
					numPlanillaInput.setValue(this.num_planilla);
				}
			}
		});
	}

	private setDataToReceipt(action: Action) {
		this.setContextDataToReceiptForm(action.conditionParams[6], action.conditionParams[7]);
	}

	public setDataToModeForm(action : Action): void {
		this.setContextDataToModeForm(action.actionParams[0], action.actionParams[1]);
		const stepperItem : CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[2]);
		stepperItem.nextButtonComponent.setDisabled(false);
	}
	
	private setContextDataToModeForm(formId : string, radioId : string): void {
		this.getModeData().subscribe({
			next : (response : ApiResponseModel) => {
				this.setResponseToForm(response, formId);
				this.setAmountToRadio(radioId, response['Data'])
			},
			error : (err : any) => {
				this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
        			true, 'Aceptar', 'Cancelar');
			}
		})
	}

	private setAmountToRadio(radioId: string, arg1: any) {
		const radioComponent : CtRadioComponent = this.utilService.getComponentRef(radioId);
		arg1.forEach((adn : ADN_PLUS) => {
			adn.ArrayEntities.List.forEach((entity : EntityField) => {
				if(entity.Name === 'MONTO_MONEDERO') 
					radioComponent.radioReceiptInputComponent.setValue(this.currencyPipe.transform(entity.Value,'₡', 'symbol', '1.0-2').toString().concat('.00'));
			});
		});
	}

	private setContextDataToReceiptForm(formId : string, receiptId : string): void {
		this.getReceiptData().subscribe({
			next : (response : ApiResponseModel) => {
				this.setResponseToForm(response, formId);
				this.setAmountToReceipt(receiptId, response['Data']);
				this.planillaData = response;
			},
			error : (err : any) => {
				this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
        			true, 'Aceptar', 'Cancelar');
			}
		})
	}

	private setAmountToReceipt(receiptId: string, resultData: any) {
		const receiptComponent : CtReceiptComponent = this.utilService.getComponentRef(receiptId);
		resultData.forEach((adn : ADN_PLUS) => {
			adn.ArrayEntities.List.forEach((entity : EntityField) => {
				if(entity.Name === 'MONTO') receiptComponent.setTotalAmount(Number(entity.Value));
			});
		});
	}

	private setResponseToForm(response: ApiResponseModel, formId: string) {
		this.utilService.setAdnToAnyComponent(formId, response['Data']);
	}

	//requests
	private getModeData(): Observable<any> {
		const request = this.getContextModeRequest();
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_RET_MODO_PAGO_SSVMN_SVA', request);
	}

	private getReceiptData(): Observable<any> {
		const request = this.getContextReceiptRequest();
		return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_RET_DET_PAGO_PLAN_SVA', request);
	}

	private getContextReceiptRequest(): any {
		return {
			"Type": 1,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
				"Data": [
					{
						"Name": "NUM_PLANILLA",
						"Alias": "NUM_PLANILLA",
						"Value": this.num_planilla
					}
				]
			},
			"Data": []
		}
	}

	private getContextModeRequest(): any {
		return {
			"Type": 1,
			"UserCode": "SVA",
			"Source": "SVA",
			"Conditions":
			{
				"Data": [
					{
						"Name": "ID_DOC_PATRONO",
						"Alias": "ID_DOC_PATRONO",
						"Value": this.doc_id_patrono
					}
				]
			},
			"Data": []
		}
	}

	/* -------------------- END CONTROLLER LOGIC ----------------- */
}